<template>
  <span v-if="typeof value !== 'undefined'">
    <i18n-n
      v-if="currencyOrDefault === 'NOK'"
      :value="value"
      locale="no"
      format="currency"
    >
      <template v-slot:currency>
        <span v-if="displayCurrency">kr</span>
        <span v-if="value < 0">&nbsp;-</span>
      </template>
      <template v-slot:minusSign></template>
      <template v-slot:decimal="props"><span v-if="!hideFraction">{{ props.decimal }}</span></template>
      <template v-slot:fraction="props">
        <span v-if="!hideFraction">{{ props.fraction == '00' ? '-' : props.fraction }}</span>
      </template>
    </i18n-n>

    <i18n-n
      v-else
      :value="value"
      locale="en"
      format="currency"
    >
      <template v-slot:currency="props"><span v-if="displayCurrency">{{ props.currency }}</span></template>
      <template v-slot:integer="props">{{ props.integer }}</template>
      <template v-slot:group="props">{{ props.group }}</template>
      <template v-slot:decimal="props"><span v-if="!hideFraction">{{ props.decimal }}</span></template>
      <template v-slot:fraction="props"><span v-if="!hideFraction">{{ props.fraction }}</span></template>
    </i18n-n>
  </span>
</template>


<script>
import { mapGetters } from 'vuex'


export default {
  props: {
    value: {
      type: Number
    },
    currency: {
      type: String
    },
    displayCurrency: {
      type: Boolean,
      default: false
    },
    hideFraction: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('settings', ['currentSettings']),

    currencyOrDefault () {
      return this.currency || this.currentSettings.currency
    }
  }
}
</script>
